import { Button, Flex, Icon, Text } from "@repo/ui";
import { useState } from "react";

type CollapsibleDetailsProps = {
	label: string;
	content: string;
};

export function CollapsibleDetails({
	label,
	content,
}: CollapsibleDetailsProps) {
	const [isExpanded, setIsExpanded] = useState(false);

	const handleCopyToClipboard = async () => {
		await navigator.clipboard.writeText(content);
	};

	return (
		<Flex column gap="xs" align="flex-start">
			<Button
				variant="text"
				onPress={() => setIsExpanded(!isExpanded)}
				aria-expanded={isExpanded}
			>
				<Flex gap="xs" align="center">
					<Icon
						name={isExpanded ? "ChevronDown" : "ChevronDown"}
						style={{
							transform: isExpanded ? "rotate(0deg)" : "rotate(-90deg)",
						}}
					/>
					<Text size="sm" color="sand11">
						{label}
					</Text>
				</Flex>
			</Button>

			{isExpanded && (
				<Flex
					column
					gap="xs"
					padding="xs"
					borderRadius="md"
					background="sand2"
					borderWidth="md"
					borderColor="sandA3"
					style={{ width: "100%" }}
				>
					<Flex justify="space-between" align="center">
						<Text size="sm" weight="medium" color="sand11">
							Error Details
						</Text>
						<Button
							variant="ghost"
							size="sm"
							onPress={handleCopyToClipboard}
							aria-label="Copy error details to clipboard"
						>
							<Icon name="Copy" />
						</Button>
					</Flex>
					<Text
						size="sm"
						color="sand12"
						style={{
							fontFamily: "monospace",
							whiteSpace: "pre-wrap",
							wordBreak: "break-word",
							maxHeight: "200px",
							overflowY: "auto",
						}}
					>
						{content}
					</Text>
				</Flex>
			)}
		</Flex>
	);
}
